import { gql } from "@apollo/client";

export const ENFORCEMENT_MANUAL_VIOLATION_POLICIES = gql`
  query EnforcementManualViolationPolicies {
    enforcement_manual_violation_policies {
      id
      code
      description
      amountDue: amount_due
    }
  }
`;

export interface EnforcementManualViolationPoliciesData {
  enforcement_manual_violation_policies: {
    id: string;
    code: string;
    description: string;
    amountDue: number;
  }[];
}

export default ENFORCEMENT_MANUAL_VIOLATION_POLICIES;
